// extracted by mini-css-extract-plugin
export default {"mediaGalleryContainer":"ProjectDetails_mediaGalleryContainer__0Ez+m"};